import { cn } from "@medimo/ui";
import { Check } from "lucide-react";

const STEPS = [1, 2, 3] as const;

export type SignUpStep = (typeof STEPS)[number];

export const SignUpStepper = ({ currentStep }: { currentStep: SignUpStep }) => (
  <ol
    aria-label={`会員登録 全${STEPS.length}ステップ中${currentStep}ステップ目`}
    className="flex items-center"
  >
    {STEPS.map((step) => {
      const isDone = step < currentStep;
      const isCurrent = step === currentStep;
      const isLast = step === STEPS.length;

      return (
        <li className={cn("flex items-center", !isLast && "flex-1")} key={step}>
          <span
            className={cn(
              "flex h-6 w-6 shrink-0 items-center justify-center rounded-full border text-xs",
              isDone || isCurrent
                ? "border-primary bg-primary text-primary-foreground"
                : "border-input bg-background text-muted-foreground",
            )}
          >
            {isDone ? <Check aria-hidden className="h-3.5 w-3.5" /> : step}
            {isCurrent ? (
              <span className="sr-only">（現在のステップ）</span>
            ) : null}
          </span>
          {isLast ? null : (
            <span
              aria-hidden
              className={cn(
                "h-px flex-1",
                step <= currentStep ? "bg-primary" : "bg-border",
              )}
            />
          )}
        </li>
      );
    })}
  </ol>
);
